import React, { useEffect, useRef, useState } from 'react'
import { IQuizOption, IQuizQuestion } from '../../models/WorkplaceQuiz'
import Conditional from '../common/Conditional'
import WorkplaceQuizModuleQuestionOption from './WorkplaceQuizModuleQuestionOption'

export interface IWorkplaceQuizModuleQuestionSingleSelectProps {
  question: IQuizQuestion
  totalSelected: number
  onSelectionChange: (options: IQuizOption[]) => void
}

const WorkplaceQuizModuleQuestionSelect = (
  props: IWorkplaceQuizModuleQuestionSingleSelectProps
) => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [question, setQuestion] = useState<IQuizQuestion>()
  const [choices, setChoices] = useState<IQuizOption[]>()
  const [selection, setSelection] = useState<IQuizOption[]>([])

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setSelection(props.question.options.filter((p) => p.selected === true))
      setQuestion(props.question)
      setChoices(props.question.options)
      setIsLoading(false)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.question])

  const selected = (option: IQuizOption) => {
    let currentSelection: IQuizOption[] = []
    if (option.multiselect === true) {
      const exists = selection.find((p) => p.id === option.id)
      if (exists) {
        if (!option.selected) {
          currentSelection = selection.filter((item) => item.id !== option.id)
        }
      } else {
        if (option.selected) {
          currentSelection = selection
          currentSelection.push(option)
        }
      }
    } else {
      choices
        .filter((p) => p.id !== option.id)
        .map((item) => {
          item.ref.current.toggleOff()
        })
      currentSelection.push(option)
    }

    setSelection(currentSelection)
    props.onSelectionChange(currentSelection)
  }
  const onKeyPressAnswerSelect = async (option: IQuizOption, event) => {

    if (event.keyCode === 13) { 
    let currentSelection: IQuizOption[] = []
    if (option.multiselect === true) {
      const exists = selection.find((p) => p.id === option.id)
      if (exists) {
        if (!option.selected) {
          currentSelection = selection.filter((item) => item.id !== option.id)
        }
      } else {
        if (option.selected) {
          currentSelection = selection
          currentSelection.push(option)
        }
      }
    } else {
      choices
        .filter((p) => p.id !== option.id)
        .map((item) => {
          item.ref.current.toggleOff()
        })
      currentSelection.push(option)
    }

    setSelection(currentSelection)
    props.onSelectionChange(currentSelection)
  }
  }



  
  return (
    <Conditional if={!isLoading}>
      <ul role="tablist">
        {choices?.map((item, index) => {
          return (
            <WorkplaceQuizModuleQuestionOption
              key={index}
              option={item}
              ref={item.ref}
              onSelection={selected}
              onKeyPress = {onKeyPressAnswerSelect}
              maxCorrect={question?.maxCorrect}
              totalSelected={props.totalSelected}
            />
          )
        })}
      </ul>
    </Conditional>
  )
}

export default WorkplaceQuizModuleQuestionSelect
